export const createFiltersOptions = (id, optionsObject): FilterOption => ({
  id: id,
  ...FilterRemap[id],
  options: optionsObject,
  value: ""
});

const FilterRemap = {
  lesson_types: { label: "Lesson Type", type: "select" },
  units: { label: "Unit", type: "select" },
  subjects: { label: "Subject", type: "select" },
  content_types: { label: "Content Type", type: "select" },
  categories: { label: "Category", type: "select" },
  statuses: { label: "Status", type: "select", multi: true },
  due_statuses: { label: "Due Status", type: "select" },
  review_statuses: { label: "Review Status", type: "select", multi: true },
  student_status: { label: "Status", type: "select" },
  student_archived: { label: "With Archived", type: "switch" },
  student_hit_target_score: { label: "Target Score", type: "select" },
  classrooms: { label: "Classroom", type: "select" },
  classrooms_archived: { label: "Archived", type: "switch" },
  instructors: { label: "Instructor", type: "select" },
  locations: { label: "Location", type: "select" },
  flagged_to_review: { label: `Include only "flagged problems"`, type: "switch" },
  reviewed_problems: { label: "With Reviewed Problems", type: "switch" },
  reviewed: { label: "With Reviewed Problems", type: "switch" },
  test_type: { label: "Test Type", type: "select" },
  without_student_id: { label: "Not Assigned to Student", type: "switch" },
  has_overdue_work: { label: "Has Overdue Work", type: "switch" },
  start_date: { label: "Start Date", type: "select" },
  end_date: { label: "End Date", type: "select" },
  classroom_tests_completed: { label: "Completed", type: "switch" },
  instructors_archived: { label: "With Archived", type: "switch" },
  without_classroom_id: { label: "Not Assigned to Classroom", type: "switch" }
};
export const createFilterSelections = (
  providedFilters: FilterSimplified[],
  selectedFilters: FilterOption[]
) => {
  let params;
  providedFilters.forEach((filter) => {
    params = { ...params, [filter.id]: filter.value };
  });
  const newFilters = selectedFilters?.map((f) => {
    const selectedFilter = providedFilters.find((filter) => filter.id === f.id);
    return selectedFilter ? { ...f, value: selectedFilter.value } : f;
  });
  return { params, newFilters };
};

export const STATUSES = ["created", "assigned", "started", "completed"];
export const DUE_STATUSES = ["none", "next_session", "due_soon", "today", "overdue"];
export const LESSON_DUE_STATUSES = ["none", "next_session", "soon", "today", "overdue"];
export const REVIEW_STATUSES = ["flagged_to_review", "reviewed_problems"];
export const STUDENTS_REVIEW_STATUSES = ["flagged_to_review", "reviewed"];
export const USER_ACCOUNT_STATUSES = ["inactive", "active"];
export const HIT_TARGET_SCORE = [
  { value: "not_hit", label: "Hasn't Hit Target Score" },
  {
    value: "hit",
    label: "Hit Target Score"
  }
];
export const TEST_TYPES = ["real_test", "practice_test"];
